export default {
    enrollmentPackageId: {
        "ui:widget": "hidden"
    }
};
